import React from 'react';

export const Footer = () => (
  <div className="fixed inset-x-0 bottom-0 bg-gray-900 p-4 text-center text-sm text-gray-300">
   Visualize user transactions by user, provider, transaction method and more.
  </div>
);
